import API from "@irati/utils/services/API"
import endpoints from "../endpoints"

const service = {}

/**
 *
 *
 * @param userSurvey object
 * @param comment object
 */
service.postUserSurveyComment = (tenantId, {id, test}, {text, driver, sentiment}) => {
  if (test || !text) return Promise.reject()

  const body = {
    text,
    tags: []
  }

  if (driver) {
    body.tags.push({
      type: "driver",
      data: {
        id: driver.id
      }
    })
  }

  if (sentiment) {
    body.tags.push({
      type: "sentiment",
      data: {
        sentiment
      }
    })
  }

  return API.post(endpoints.commentsUserSurvey(tenantId, id), body, {unAuth: true})
}

export const postUserSurveyComment = service.postUserSurveyComment

export default service
